export const UnleashFlags = {
  dfPaymentsCommission: "df.payments.commision",

  newAuthorization: "web.show.new.authorization",
  foreignPassportAuthorization: "web.authorization.foreign.passport",

  showAlertBanner: "web.show.alert.banner",
  sbpTransferEnabled: "web.sbp.transfers.enabled",
  sbpTransferWhiteList: "web.sbp.transfers.white-list",
  debtRepaymentOptionsEnabled: "web.debt.repayment.options",
};
